export default __webpack_public_path__ + "static/media/app-icon.6f14c054.png";